import { takeEvery, put, call } from "redux-saga/effects"

//Parsing Resume
import { GET_VIDEO_RESUME } from "./actionTypes"
import { getVideoResumeSuccessfull, getVideoResumeFailed } from "./actions"

import * as constClass from "../../../../common/constant/constantURL"
import { getCall } from "../../../../helpers/fakebackend_helper"

function* getVideoResumeF({ payload: { candidateId, download } }) {
  try {
    var url = constClass.REST_API_CANDIDATE_VIDEO_RESUME;
    var responsJSON = yield call(getCall, url + "?candidateId=" + candidateId+"&download="+download);
    yield put(getVideoResumeSuccessfull(responsJSON))
  }catch (error) {
    yield put(getVideoResumeFailed(error))
  }
}

function* getVideoResumeSaga() {
  yield takeEvery(GET_VIDEO_RESUME, getVideoResumeF)
}

export default getVideoResumeSaga